import { io, Socket } from "socket.io-client";
import { SOCKET_URL } from "./constants";
import useUserStore from "./Stores/userStore";



// Ensure you're connecting to the correct namespace
const socket: Socket = io(SOCKET_URL, {
    transports: ["websocket"], // Use WebSocket transport
    reconnectionAttempts: 5, // Retry up to 5 times
    reconnectionDelay: 1000, // Delay between reconnections
    autoConnect: true, // Auto-connect on load
});

socket.on("connect", () => {
    socket.emit("addUser", useUserStore?.getState()?.user?._id);
    // console.log("✅ Connected to server with ID:", socket.id);
});

// socket.on("connect_error", (error) => {
//     console.error("❌ Connection error:", error);
// });

// socket.on("disconnect", () => {
//     console.log("❌ Disconnected from server");
// });

export default socket;
